var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2159 1440",
    width: 2159,
    height: 1440,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2159.94 1.06v1438.23h-2157.35v-1438.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,2306.151,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,2136.977,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,1967.799,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.073,166.073,1798.627,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.074,166.074,1629.446,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,1460.274,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,1291.096,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,1121.922,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.073,166.073,952.75,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,783.572,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,614.395,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,445.222,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.071,166.071,276.047,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.072,166.072,106.871,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.072,166.072,-62.306,-167.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,2306.151,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2136.976,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,1967.798,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.072,166.072,1798.626,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,1629.445,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.068,166.068,1460.273,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,1291.096,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,1121.921,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.072,166.072,952.749,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,783.571,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,614.394,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,445.221,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,276.046,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.071,166.071,106.87,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,-62.306,1.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,2306.151,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,2136.977,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,1967.799,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,1798.627,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.073,166.073,1629.446,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.069,166.069,1460.274,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,1291.096,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,1121.922,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,952.749,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,783.572,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,614.395,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,445.222,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,276.047,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,106.871,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,-62.306,171.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.073,166.073,2306.153,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,2136.978,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.073,166.073,1967.8,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,1798.628,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.078,166.078,1629.447,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,1460.275,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.073,166.073,1291.098,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.071,166.071,1121.923,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,952.751,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.073,166.073,783.573,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,614.396,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,445.223,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,276.048,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g59",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,106.872,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,-62.304,340.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g61",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,2306.152,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,2136.977,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,1967.799,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1798.627,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,1629.447,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g66",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.069,166.069,1460.275,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,1291.097,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.071,166.071,1121.922,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g69",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,952.75,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g70",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,783.572,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g71",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,614.396,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,445.223,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g73",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,276.048,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g74",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,106.871,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g75",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,-62.305,509.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g76",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,2306.151,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g77",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2136.976,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g78",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1967.798,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g79",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.071,166.071,1798.626,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g80",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1629.445,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g81",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.071,166.071,1460.273,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g82",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1291.096,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g83",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1121.921,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g84",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.071,166.071,952.749,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g85",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,783.571,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g86",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.069,166.069,614.394,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g87",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,445.221,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g88",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,276.046,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g89",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.069,166.069,106.87,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g90",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,-62.306,678.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g91",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,2306.153,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g92",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,2136.979,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g93",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1967.801,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g94",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,1798.629,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.082,166.082,-166.074,166.074,1629.448,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g96",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1460.276,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g97",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1291.098,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g98",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.071,166.071,1121.924,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g99",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,952.751,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g100",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,783.574,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g101",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,614.397,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g102",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,445.224,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g103",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,276.049,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g104",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,106.873,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g105",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,-62.304,847.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g106",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.075,166.075,2306.152,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g107",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,2136.977,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g108",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.075,166.075,1967.799,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g109",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,1798.627,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g110",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.076,166.076,1629.447,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g111",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1460.275,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g112",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.075,166.075,1291.097,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g113",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,1121.922,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g114",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,952.75,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g115",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,783.572,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g116",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.07,166.07,614.396,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g117",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,445.223,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g118",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,276.048,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g119",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.07,166.07,106.871,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g120",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,-62.305,1017.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g121",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,2306.153,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g122",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,2136.979,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g123",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1967.801,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g124",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,1798.629,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g125",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.082,166.082,-166.074,166.074,1629.448,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g126",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1460.276,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g127",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1291.098,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g128",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.071,166.071,1121.924,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g129",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,952.752,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g130",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.076,166.076,783.574,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g131",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,614.397,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g132",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,445.224,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g133",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,276.049,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g134",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,106.873,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g135",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,-62.304,1186.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g136",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,2306.151,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g137",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2136.976,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g138",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1967.798,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g139",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.075,166.075,1798.626,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g140",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,1629.445,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g141",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.071,166.071,1460.273,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g142",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,1291.096,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g143",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,1121.921,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g144",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.075,166.075,952.749,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g145",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,783.571,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g146",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.069,166.069,614.394,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g147",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.071,166.071,445.221,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g148",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,276.046,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g149",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.069,166.069,106.87,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g150",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,-62.306,1355.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g151",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,2221.56,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g152",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2052.388,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g153",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,1883.211,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g154",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1714.039,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g155",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.074,166.074,1544.858,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g156",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1375.686,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g157",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,1206.505,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g158",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1037.333,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g159",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,868.161,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g160",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,698.982,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g161",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,529.806,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g162",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,360.634,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g163",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,191.457,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g164",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,22.282,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g165",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,-146.894,-251.816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g166",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,2221.56,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g167",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,2052.388,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g168",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,1883.21,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g169",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,1714.038,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g170",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,1544.857,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g171",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,1375.685,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g172",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,1206.505,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g173",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,1037.332,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g174",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,868.16,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g175",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,698.981,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g176",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.078,166.078,529.805,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g177",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,360.633,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g178",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,191.457,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g179",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,22.282,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g180",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.078,166.078,-146.895,-82.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g181",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,2221.56,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g182",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,2052.388,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g183",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,1883.21,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g184",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,1714.038,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g185",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,1544.857,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g186",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,1375.685,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g187",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,1206.505,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g188",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.073,166.073,1037.332,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g189",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.076,166.076,868.16,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g190",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.072,166.072,698.981,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g191",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,529.805,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g192",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,360.633,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g193",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,191.457,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g194",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,22.282,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g195",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,-146.895,86.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g196",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,2221.56,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g197",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2052.388,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g198",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.076,166.076,1883.211,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g199",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1714.039,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g200",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1544.858,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g201",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1375.686,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g202",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,1206.505,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g203",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1037.333,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g204",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,868.161,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g205",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.077,166.077,698.982,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g206",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,529.806,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g207",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,360.634,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g208",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,191.457,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g209",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,22.282,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g210",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,-146.894,255.714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g211",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,2221.558,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g212",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.075,166.075,2052.386,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g213",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.074,166.074,1883.209,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g214",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.075,166.075,1714.036,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g215",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1544.856,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g216",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.074,166.074,-166.067,166.067,1375.684,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g217",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1206.503,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g218",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.067,166.067,1037.331,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g219",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.075,166.075,868.159,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g220",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.075,166.075,698.98,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g221",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,529.804,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g222",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.075,166.075,-166.067,166.067,360.631,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g223",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,191.455,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g224",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.076,166.076,-166.072,166.072,22.28,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g225",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.07,166.07,-146.896,424.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g226",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.073,166.073,2221.56,594.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g227",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,2052.388,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g228",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1883.211,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g229",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1714.039,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g230",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.081,166.081,1544.858,594.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g231",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1375.686,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g232",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.073,166.073,1206.505,594.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g233",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1037.333,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g234",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,868.161,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g235",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.072,166.072,698.982,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g236",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,529.806,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g237",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,360.634,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g238",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.074,166.074,191.457,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g239",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,22.282,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g240",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.074,166.074,-146.894,594.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g241",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.072,166.072,2221.56,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g242",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,2052.388,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g243",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.071,166.071,1883.211,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g244",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1714.039,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g245",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.072,166.072,1544.858,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g246",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1375.686,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g247",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.072,166.072,1206.505,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g248",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1037.333,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g249",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,868.161,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g250",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,698.982,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g251",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.074,166.074,529.806,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g252",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,360.634,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g253",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.07,166.07,191.457,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g254",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,22.282,763.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g255",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.074,166.074,-146.894,763.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g256",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,2221.56,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g257",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,2052.388,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g258",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1883.211,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g259",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,1714.039,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g260",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.072,166.072,1544.858,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g261",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1375.686,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g262",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,1206.505,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g263",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,1037.333,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g264",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.077,166.077,868.161,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g265",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,698.982,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g266",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,529.806,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g267",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.073,166.073,360.634,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g268",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,191.457,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g269",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.074,166.074,22.282,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g270",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,-146.894,932.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g271",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.082,166.082,-166.074,166.074,2221.562,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g272",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,2052.39,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g273",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.076,166.076,1883.212,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g274",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,1714.04,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g275",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.082,166.082,-166.078,166.078,1544.859,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g276",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.078,166.078,1375.687,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g277",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.082,166.082,-166.074,166.074,1206.507,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g278",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.078,166.078,1037.334,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g279",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.07,166.07,868.162,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g280",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.077,166.077,698.983,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g281",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.08,166.08,529.807,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g282",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.078,166.078,360.635,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g283",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.075,166.075,191.459,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g284",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,22.284,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g285",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,-146.893,1101.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g286",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.076,166.076,2221.56,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g287",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,2052.388,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g288",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.075,166.075,1883.211,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g289",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,1714.039,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g290",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.072,166.072,1544.858,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g291",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1375.686,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g292",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.081,166.081,-166.076,166.076,1206.505,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g293",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.068,166.068,1037.333,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g294",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,868.161,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g295",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.08,166.08,-166.076,166.076,698.982,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g296",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,529.806,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g297",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.077,166.077,-166.072,166.072,360.634,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g298",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.079,166.079,191.457,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g299",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.078,166.078,-166.073,166.073,22.282,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g300",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(166.079,166.079,-166.07,166.07,-146.894,1270.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1323.179,0,0,1323.179,1081.268,720.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#ffffff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: url(#g2) } \n\t\t.s3 { fill: url(#g3) } \n\t\t.s4 { fill: url(#g4) } \n\t\t.s5 { fill: url(#g5) } \n\t\t.s6 { fill: url(#g6) } \n\t\t.s7 { fill: url(#g7) } \n\t\t.s8 { fill: url(#g8) } \n\t\t.s9 { fill: url(#g9) } \n\t\t.s10 { fill: url(#g10) } \n\t\t.s11 { fill: url(#g11) } \n\t\t.s12 { fill: url(#g12) } \n\t\t.s13 { fill: url(#g13) } \n\t\t.s14 { fill: url(#g14) } \n\t\t.s15 { fill: url(#g15) } \n\t\t.s16 { fill: url(#g16) } \n\t\t.s17 { fill: url(#g17) } \n\t\t.s18 { fill: url(#g18) } \n\t\t.s19 { fill: url(#g19) } \n\t\t.s20 { fill: url(#g20) } \n\t\t.s21 { fill: url(#g21) } \n\t\t.s22 { fill: url(#g22) } \n\t\t.s23 { fill: url(#g23) } \n\t\t.s24 { fill: url(#g24) } \n\t\t.s25 { fill: url(#g25) } \n\t\t.s26 { fill: url(#g26) } \n\t\t.s27 { fill: url(#g27) } \n\t\t.s28 { fill: url(#g28) } \n\t\t.s29 { fill: url(#g29) } \n\t\t.s30 { fill: url(#g30) } \n\t\t.s31 { fill: url(#g31) } \n\t\t.s32 { fill: url(#g32) } \n\t\t.s33 { fill: url(#g33) } \n\t\t.s34 { fill: url(#g34) } \n\t\t.s35 { fill: url(#g35) } \n\t\t.s36 { fill: url(#g36) } \n\t\t.s37 { fill: url(#g37) } \n\t\t.s38 { fill: url(#g38) } \n\t\t.s39 { fill: url(#g39) } \n\t\t.s40 { fill: url(#g40) } \n\t\t.s41 { fill: url(#g41) } \n\t\t.s42 { fill: url(#g42) } \n\t\t.s43 { fill: url(#g43) } \n\t\t.s44 { fill: url(#g44) } \n\t\t.s45 { fill: url(#g45) } \n\t\t.s46 { fill: url(#g46) } \n\t\t.s47 { fill: url(#g47) } \n\t\t.s48 { fill: url(#g48) } \n\t\t.s49 { fill: url(#g49) } \n\t\t.s50 { fill: url(#g50) } \n\t\t.s51 { fill: url(#g51) } \n\t\t.s52 { fill: url(#g52) } \n\t\t.s53 { fill: url(#g53) } \n\t\t.s54 { fill: url(#g54) } \n\t\t.s55 { fill: url(#g55) } \n\t\t.s56 { fill: url(#g56) } \n\t\t.s57 { fill: url(#g57) } \n\t\t.s58 { fill: url(#g58) } \n\t\t.s59 { fill: url(#g59) } \n\t\t.s60 { fill: url(#g60) } \n\t\t.s61 { fill: url(#g61) } \n\t\t.s62 { fill: url(#g62) } \n\t\t.s63 { fill: url(#g63) } \n\t\t.s64 { fill: url(#g64) } \n\t\t.s65 { fill: url(#g65) } \n\t\t.s66 { fill: url(#g66) } \n\t\t.s67 { fill: url(#g67) } \n\t\t.s68 { fill: url(#g68) } \n\t\t.s69 { fill: url(#g69) } \n\t\t.s70 { fill: url(#g70) } \n\t\t.s71 { fill: url(#g71) } \n\t\t.s72 { fill: url(#g72) } \n\t\t.s73 { fill: url(#g73) } \n\t\t.s74 { fill: url(#g74) } \n\t\t.s75 { fill: url(#g75) } \n\t\t.s76 { fill: url(#g76) } \n\t\t.s77 { fill: url(#g77) } \n\t\t.s78 { fill: url(#g78) } \n\t\t.s79 { fill: url(#g79) } \n\t\t.s80 { fill: url(#g80) } \n\t\t.s81 { fill: url(#g81) } \n\t\t.s82 { fill: url(#g82) } \n\t\t.s83 { fill: url(#g83) } \n\t\t.s84 { fill: url(#g84) } \n\t\t.s85 { fill: url(#g85) } \n\t\t.s86 { fill: url(#g86) } \n\t\t.s87 { fill: url(#g87) } \n\t\t.s88 { fill: url(#g88) } \n\t\t.s89 { fill: url(#g89) } \n\t\t.s90 { fill: url(#g90) } \n\t\t.s91 { fill: url(#g91) } \n\t\t.s92 { fill: url(#g92) } \n\t\t.s93 { fill: url(#g93) } \n\t\t.s94 { fill: url(#g94) } \n\t\t.s95 { fill: url(#g95) } \n\t\t.s96 { fill: url(#g96) } \n\t\t.s97 { fill: url(#g97) } \n\t\t.s98 { fill: url(#g98) } \n\t\t.s99 { fill: url(#g99) } \n\t\t.s100 { fill: url(#g100) } \n\t\t.s101 { fill: url(#g101) } \n\t\t.s102 { fill: url(#g102) } \n\t\t.s103 { fill: url(#g103) } \n\t\t.s104 { fill: url(#g104) } \n\t\t.s105 { fill: url(#g105) } \n\t\t.s106 { fill: url(#g106) } \n\t\t.s107 { fill: url(#g107) } \n\t\t.s108 { fill: url(#g108) } \n\t\t.s109 { fill: url(#g109) } \n\t\t.s110 { fill: url(#g110) } \n\t\t.s111 { fill: url(#g111) } \n\t\t.s112 { fill: url(#g112) } \n\t\t.s113 { fill: url(#g113) } \n\t\t.s114 { fill: url(#g114) } \n\t\t.s115 { fill: url(#g115) } \n\t\t.s116 { fill: url(#g116) } \n\t\t.s117 { fill: url(#g117) } \n\t\t.s118 { fill: url(#g118) } \n\t\t.s119 { fill: url(#g119) } \n\t\t.s120 { fill: url(#g120) } \n\t\t.s121 { fill: url(#g121) } \n\t\t.s122 { fill: url(#g122) } \n\t\t.s123 { fill: url(#g123) } \n\t\t.s124 { fill: url(#g124) } \n\t\t.s125 { fill: url(#g125) } \n\t\t.s126 { fill: url(#g126) } \n\t\t.s127 { fill: url(#g127) } \n\t\t.s128 { fill: url(#g128) } \n\t\t.s129 { fill: url(#g129) } \n\t\t.s130 { fill: url(#g130) } \n\t\t.s131 { fill: url(#g131) } \n\t\t.s132 { fill: url(#g132) } \n\t\t.s133 { fill: url(#g133) } \n\t\t.s134 { fill: url(#g134) } \n\t\t.s135 { fill: url(#g135) } \n\t\t.s136 { fill: url(#g136) } \n\t\t.s137 { fill: url(#g137) } \n\t\t.s138 { fill: url(#g138) } \n\t\t.s139 { fill: url(#g139) } \n\t\t.s140 { fill: url(#g140) } \n\t\t.s141 { fill: url(#g141) } \n\t\t.s142 { fill: url(#g142) } \n\t\t.s143 { fill: url(#g143) } \n\t\t.s144 { fill: url(#g144) } \n\t\t.s145 { fill: url(#g145) } \n\t\t.s146 { fill: url(#g146) } \n\t\t.s147 { fill: url(#g147) } \n\t\t.s148 { fill: url(#g148) } \n\t\t.s149 { fill: url(#g149) } \n\t\t.s150 { fill: url(#g150) } \n\t\t.s151 { fill: url(#g151) } \n\t\t.s152 { fill: url(#g152) } \n\t\t.s153 { fill: url(#g153) } \n\t\t.s154 { fill: url(#g154) } \n\t\t.s155 { fill: url(#g155) } \n\t\t.s156 { fill: url(#g156) } \n\t\t.s157 { fill: url(#g157) } \n\t\t.s158 { fill: url(#g158) } \n\t\t.s159 { fill: url(#g159) } \n\t\t.s160 { fill: url(#g160) } \n\t\t.s161 { fill: url(#g161) } \n\t\t.s162 { fill: url(#g162) } \n\t\t.s163 { fill: url(#g163) } \n\t\t.s164 { fill: url(#g164) } \n\t\t.s165 { fill: url(#g165) } \n\t\t.s166 { fill: url(#g166) } \n\t\t.s167 { fill: url(#g167) } \n\t\t.s168 { fill: url(#g168) } \n\t\t.s169 { fill: url(#g169) } \n\t\t.s170 { fill: url(#g170) } \n\t\t.s171 { fill: url(#g171) } \n\t\t.s172 { fill: url(#g172) } \n\t\t.s173 { fill: url(#g173) } \n\t\t.s174 { fill: url(#g174) } \n\t\t.s175 { fill: url(#g175) } \n\t\t.s176 { fill: url(#g176) } \n\t\t.s177 { fill: url(#g177) } \n\t\t.s178 { fill: url(#g178) } \n\t\t.s179 { fill: url(#g179) } \n\t\t.s180 { fill: url(#g180) } \n\t\t.s181 { fill: url(#g181) } \n\t\t.s182 { fill: url(#g182) } \n\t\t.s183 { fill: url(#g183) } \n\t\t.s184 { fill: url(#g184) } \n\t\t.s185 { fill: url(#g185) } \n\t\t.s186 { fill: url(#g186) } \n\t\t.s187 { fill: url(#g187) } \n\t\t.s188 { fill: url(#g188) } \n\t\t.s189 { fill: url(#g189) } \n\t\t.s190 { fill: url(#g190) } \n\t\t.s191 { fill: url(#g191) } \n\t\t.s192 { fill: url(#g192) } \n\t\t.s193 { fill: url(#g193) } \n\t\t.s194 { fill: url(#g194) } \n\t\t.s195 { fill: url(#g195) } \n\t\t.s196 { fill: url(#g196) } \n\t\t.s197 { fill: url(#g197) } \n\t\t.s198 { fill: url(#g198) } \n\t\t.s199 { fill: url(#g199) } \n\t\t.s200 { fill: url(#g200) } \n\t\t.s201 { fill: url(#g201) } \n\t\t.s202 { fill: url(#g202) } \n\t\t.s203 { fill: url(#g203) } \n\t\t.s204 { fill: url(#g204) } \n\t\t.s205 { fill: url(#g205) } \n\t\t.s206 { fill: url(#g206) } \n\t\t.s207 { fill: url(#g207) } \n\t\t.s208 { fill: url(#g208) } \n\t\t.s209 { fill: url(#g209) } \n\t\t.s210 { fill: url(#g210) } \n\t\t.s211 { fill: url(#g211) } \n\t\t.s212 { fill: url(#g212) } \n\t\t.s213 { fill: url(#g213) } \n\t\t.s214 { fill: url(#g214) } \n\t\t.s215 { fill: url(#g215) } \n\t\t.s216 { fill: url(#g216) } \n\t\t.s217 { fill: url(#g217) } \n\t\t.s218 { fill: url(#g218) } \n\t\t.s219 { fill: url(#g219) } \n\t\t.s220 { fill: url(#g220) } \n\t\t.s221 { fill: url(#g221) } \n\t\t.s222 { fill: url(#g222) } \n\t\t.s223 { fill: url(#g223) } \n\t\t.s224 { fill: url(#g224) } \n\t\t.s225 { fill: url(#g225) } \n\t\t.s226 { fill: url(#g226) } \n\t\t.s227 { fill: url(#g227) } \n\t\t.s228 { fill: url(#g228) } \n\t\t.s229 { fill: url(#g229) } \n\t\t.s230 { fill: url(#g230) } \n\t\t.s231 { fill: url(#g231) } \n\t\t.s232 { fill: url(#g232) } \n\t\t.s233 { fill: url(#g233) } \n\t\t.s234 { fill: url(#g234) } \n\t\t.s235 { fill: url(#g235) } \n\t\t.s236 { fill: url(#g236) } \n\t\t.s237 { fill: url(#g237) } \n\t\t.s238 { fill: url(#g238) } \n\t\t.s239 { fill: url(#g239) } \n\t\t.s240 { fill: url(#g240) } \n\t\t.s241 { fill: url(#g241) } \n\t\t.s242 { fill: url(#g242) } \n\t\t.s243 { fill: url(#g243) } \n\t\t.s244 { fill: url(#g244) } \n\t\t.s245 { fill: url(#g245) } \n\t\t.s246 { fill: url(#g246) } \n\t\t.s247 { fill: url(#g247) } \n\t\t.s248 { fill: url(#g248) } \n\t\t.s249 { fill: url(#g249) } \n\t\t.s250 { fill: url(#g250) } \n\t\t.s251 { fill: url(#g251) } \n\t\t.s252 { fill: url(#g252) } \n\t\t.s253 { fill: url(#g253) } \n\t\t.s254 { fill: url(#g254) } \n\t\t.s255 { fill: url(#g255) } \n\t\t.s256 { fill: url(#g256) } \n\t\t.s257 { fill: url(#g257) } \n\t\t.s258 { fill: url(#g258) } \n\t\t.s259 { fill: url(#g259) } \n\t\t.s260 { fill: url(#g260) } \n\t\t.s261 { fill: url(#g261) } \n\t\t.s262 { fill: url(#g262) } \n\t\t.s263 { fill: url(#g263) } \n\t\t.s264 { fill: url(#g264) } \n\t\t.s265 { fill: url(#g265) } \n\t\t.s266 { fill: url(#g266) } \n\t\t.s267 { fill: url(#g267) } \n\t\t.s268 { fill: url(#g268) } \n\t\t.s269 { fill: url(#g269) } \n\t\t.s270 { fill: url(#g270) } \n\t\t.s271 { fill: url(#g271) } \n\t\t.s272 { fill: url(#g272) } \n\t\t.s273 { fill: url(#g273) } \n\t\t.s274 { fill: url(#g274) } \n\t\t.s275 { fill: url(#g275) } \n\t\t.s276 { fill: url(#g276) } \n\t\t.s277 { fill: url(#g277) } \n\t\t.s278 { fill: url(#g278) } \n\t\t.s279 { fill: url(#g279) } \n\t\t.s280 { fill: url(#g280) } \n\t\t.s281 { fill: url(#g281) } \n\t\t.s282 { fill: url(#g282) } \n\t\t.s283 { fill: url(#g283) } \n\t\t.s284 { fill: url(#g284) } \n\t\t.s285 { fill: url(#g285) } \n\t\t.s286 { fill: url(#g286) } \n\t\t.s287 { fill: url(#g287) } \n\t\t.s288 { fill: url(#g288) } \n\t\t.s289 { fill: url(#g289) } \n\t\t.s290 { fill: url(#g290) } \n\t\t.s291 { fill: url(#g291) } \n\t\t.s292 { fill: url(#g292) } \n\t\t.s293 { fill: url(#g293) } \n\t\t.s294 { fill: url(#g294) } \n\t\t.s295 { fill: url(#g295) } \n\t\t.s296 { fill: url(#g296) } \n\t\t.s297 { fill: url(#g297) } \n\t\t.s298 { fill: url(#g298) } \n\t\t.s299 { fill: url(#g299) } \n\t\t.s300 { fill: url(#g300) } \n\t\t.s301 { mix-blend-mode: overlay;fill: url(#g301) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m2307.8 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2138.6 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1969.4 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1800.3 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 1.2c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1631.1 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1461.9 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1292.7 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m1123.6 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 1.2c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m954.4 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m785.2 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m616 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m446.9 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 1.2c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.4-40 82.4-82.3 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m277.7 84.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m108.5 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m-60.7 84.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 1.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m2307.8 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m2138.6 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m1969.4 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m1800.3 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 170.4c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1631.1 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1461.9 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m1292.7 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1123.6 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 170.4c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m954.4 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m785.2 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m616 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m446.9 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 170.4c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.4-39.9 82.4-82.2 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m277.7 253.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m108.5 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.6 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m-60.7 253.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.6 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 170.4c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m2307.8 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m2138.6 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m1969.4 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m1800.3 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 339.5c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m1631.1 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1461.9 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m1292.7 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m1123.6 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 339.5c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m954.4 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m785.2 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m616 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m446.9 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 339.5c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.4-39.9 82.4-82.3 0-42.3-73.6-78.1-82.4-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m277.7 423c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m108.5 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m-60.7 423c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 339.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m2307.8 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m2138.6 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m1969.4 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m1800.3 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 508.7c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m1631.1 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1461.9 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m1292.7 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m1123.6 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 508.7c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m954.4 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m785.2 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m616 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m446.9 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 508.7c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.4-39.9 82.4-82.3 0-42.3-73.6-78.1-82.4-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m277.7 592.1c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m108.5 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m-60.7 592.1c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 508.7c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m2307.8 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m2138.6 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m1969.4 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1800.3 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 677.9c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m1631.1 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m1461.9 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m1292.7 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m1123.6 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 677.9c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m954.4 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m785.2 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m616 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s72",
    d: "m446.9 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 677.9c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.4-40 82.4-82.3 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s73",
    d: "m277.7 761.3c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m108.5 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s75",
    d: "m-60.7 761.3c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 677.9c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m2307.8 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s77",
    d: "m2138.6 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s78",
    d: "m1969.4 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s79",
    d: "m1800.3 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 847.1c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s80",
    d: "m1631.1 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s81",
    d: "m1461.9 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s82",
    d: "m1292.7 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s83",
    d: "m1123.6 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 847.1c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s84",
    d: "m954.4 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s85",
    d: "m785.2 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s86",
    d: "m616 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s87",
    d: "m446.9 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 847.1c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.4-39.9 82.4-82.2 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s88",
    d: "m277.7 930.5c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s89",
    d: "m108.5 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s90",
    d: "m-60.7 930.5c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 847.1c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m2307.8 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m2138.6 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s93",
    d: "m1969.4 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s94",
    d: "m1800.3 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 1016.2c0 46.8-84.5 84.6-84.5 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s95",
    d: "m1631.1 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s96",
    d: "m1461.9 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s97",
    d: "m1292.7 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s98",
    d: "m1123.6 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 1016.2c0 46.8-84.5 84.6-84.5 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s99",
    d: "m954.4 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s100",
    d: "m785.2 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s101",
    d: "m616 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s102",
    d: "m446.9 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 1016.2c0 46.8-84.5 84.6-84.5 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.4-39.9 82.4-82.3 0-42.3-73.6-78.1-82.4-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s103",
    d: "m277.7 1099.7c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s104",
    d: "m108.5 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s105",
    d: "m-60.7 1099.7c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 1016.2c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s106",
    d: "m2307.8 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s107",
    d: "m2138.6 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s108",
    d: "m1969.4 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s109",
    d: "m1800.3 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 1185.4c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s110",
    d: "m1631.1 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s111",
    d: "m1461.9 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s112",
    d: "m1292.7 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s113",
    d: "m1123.6 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 1185.4c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s114",
    d: "m954.4 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s115",
    d: "m785.2 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s116",
    d: "m616 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s117",
    d: "m446.9 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 1185.4c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.4-39.9 82.4-82.3 0-42.4-73.6-78.1-82.4-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s118",
    d: "m277.7 1268.8c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s119",
    d: "m108.5 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s120",
    d: "m-60.7 1268.8c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 1185.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s121",
    d: "m2307.8 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s122",
    d: "m2138.6 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s123",
    d: "m1969.4 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s124",
    d: "m1800.3 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 1354.6c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s125",
    d: "m1631.1 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s126",
    d: "m1461.9 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s127",
    d: "m1292.7 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s128",
    d: "m1123.6 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 1354.6c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s129",
    d: "m954.4 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s130",
    d: "m785.2 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s131",
    d: "m616 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s132",
    d: "m446.9 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 1354.6c0 46.7-84.5 84.6-84.5 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.5 37.9 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.4-40 82.4-82.3 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s133",
    d: "m277.7 1438c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s134",
    d: "m108.5 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s135",
    d: "m-60.7 1438c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.5 6.5 3.1 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 1354.6c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s136",
    d: "m2307.8 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2392.4 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s137",
    d: "m2138.6 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2223.2 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s138",
    d: "m1969.4 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2054 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s139",
    d: "m1800.3 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1884.8 1523.8c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s140",
    d: "m1631.1 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1715.7 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s141",
    d: "m1461.9 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s142",
    d: "m1292.7 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1377.3 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s143",
    d: "m1123.6 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1208.1 1523.8c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s144",
    d: "m954.4 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1039 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s145",
    d: "m785.2 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m869.8 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s146",
    d: "m616 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m700.6 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s147",
    d: "m446.9 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m531.4 1523.8c0 46.7-84.5 84.5-84.5 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.5 37.8 84.5 84.6zm-167 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.4-39.9 82.4-82.2 0-42.4-73.6-78.2-82.4-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s148",
    d: "m277.7 1607.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.9 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m362.3 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s149",
    d: "m108.5 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.9 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m193.1 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s150",
    d: "m-60.7 1607.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m23.9 1523.8c0 46.7-84.6 84.5-84.6 84.5 0 0-84.6-37.8-84.6-84.5 0-46.8 84.6-84.6 84.6-84.6 0 0 84.6 37.8 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s151",
    d: "m2223.2 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s152",
    d: "m2054 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s153",
    d: "m1884.8 0c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s154",
    d: "m1715.7 0c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s155",
    d: "m1546.5 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s156",
    d: "m1377.3 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s157",
    d: "m1208.1 0c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s158",
    d: "m1039 0c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s159",
    d: "m869.8 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s160",
    d: "m700.6 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s161",
    d: "m531.4 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s162",
    d: "m362.3 0c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s163",
    d: "m193.1 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s164",
    d: "m23.9 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s165",
    d: "m-145.3 0c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7-83.4c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s166",
    d: "m2223.2 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s167",
    d: "m2054 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s168",
    d: "m1884.8 169.2c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s169",
    d: "m1715.7 169.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s170",
    d: "m1546.5 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1546.5 1.2c0 0 84.6 37.9 84.6 84.6 0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6zm-82.5 84.6c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s171",
    d: "m1377.3 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s172",
    d: "m1208.1 169.2c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s173",
    d: "m1039 169.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s174",
    d: "m869.8 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s175",
    d: "m700.6 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s176",
    d: "m531.4 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s177",
    d: "m362.3 169.2c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s178",
    d: "m193.1 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s179",
    d: "m23.9 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s180",
    d: "m-145.3 169.2c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 85.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s181",
    d: "m2223.2 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s182",
    d: "m2054 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s183",
    d: "m1884.8 338.4c-6.4-3-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s184",
    d: "m1715.7 338.4c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s185",
    d: "m1546.5 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s186",
    d: "m1377.3 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s187",
    d: "m1208.1 338.4c-6.4-3-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s188",
    d: "m1039 338.4c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s189",
    d: "m869.8 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s190",
    d: "m700.6 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s191",
    d: "m531.4 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s192",
    d: "m362.3 338.4c-6.5-3-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s193",
    d: "m193.1 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s194",
    d: "m23.9 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s195",
    d: "m-145.3 338.4c-6.5-3-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 254.9c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s196",
    d: "m2223.2 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s197",
    d: "m2054 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s198",
    d: "m1884.8 507.6c-6.4-3.1-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s199",
    d: "m1715.7 507.6c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s200",
    d: "m1546.5 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s201",
    d: "m1377.3 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s202",
    d: "m1208.1 507.6c-6.4-3.1-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s203",
    d: "m1039 507.6c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s204",
    d: "m869.8 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s205",
    d: "m700.6 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s206",
    d: "m531.4 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s207",
    d: "m362.3 507.6c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s208",
    d: "m193.1 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s209",
    d: "m23.9 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s210",
    d: "m-145.3 507.6c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 424.1c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s211",
    d: "m2223.2 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s212",
    d: "m2054 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s213",
    d: "m1884.8 676.7c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s214",
    d: "m1715.7 676.7c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s215",
    d: "m1546.5 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s216",
    d: "m1377.3 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s217",
    d: "m1208.1 676.7c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s218",
    d: "m1039 676.7c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s219",
    d: "m869.8 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s220",
    d: "m700.6 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s221",
    d: "m531.4 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s222",
    d: "m362.3 676.7c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s223",
    d: "m193.1 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s224",
    d: "m23.9 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s225",
    d: "m-145.3 676.7c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 593.3c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s226",
    d: "m2223.2 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s227",
    d: "m2054 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s228",
    d: "m1884.8 845.9c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s229",
    d: "m1715.7 845.9c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s230",
    d: "m1546.5 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s231",
    d: "m1377.3 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s232",
    d: "m1208.1 845.9c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s233",
    d: "m1039 845.9c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s234",
    d: "m869.8 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s235",
    d: "m700.6 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s236",
    d: "m531.4 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s237",
    d: "m362.3 845.9c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s238",
    d: "m193.1 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s239",
    d: "m23.9 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.2 8.8-4.1 82.5-39.9 82.5-82.2 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s240",
    d: "m-145.3 845.9c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 762.5c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.2 8.9-4.1 82.5-39.9 82.5-82.2 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s241",
    d: "m2223.2 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s242",
    d: "m2054 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s243",
    d: "m1884.8 1015.1c-6.4-3-83.5-39.6-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s244",
    d: "m1715.7 1015.1c-6.5-3-83.6-39.6-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s245",
    d: "m1546.5 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s246",
    d: "m1377.3 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s247",
    d: "m1208.1 1015.1c-6.4-3-83.5-39.6-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s248",
    d: "m1039 1015.1c-6.5-3-83.6-39.6-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s249",
    d: "m869.8 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s250",
    d: "m700.6 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s251",
    d: "m531.4 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s252",
    d: "m362.3 1015.1c-6.5-3-83.6-39.6-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.9 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s253",
    d: "m193.1 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.9-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s254",
    d: "m23.9 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.6-37.8-84.6-84.6 0-46.7 84.6-84.5 84.6-84.5 0 0 84.6 37.8 84.6 84.5zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.2-8.8 4.1-82.5 39.9-82.5 82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s255",
    d: "m-145.3 1015.1c-6.5-3-83.5-39.6-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.9-77.1 80.5-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 931.6c0 46.8-84.6 84.6-84.6 84.6 0 0-84.5-37.8-84.5-84.6 0-46.7 84.5-84.5 84.5-84.5 0 0 84.6 37.8 84.6 84.5zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.2-8.8 4.1-82.4 39.9-82.4 82.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s256",
    d: "m2223.2 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s257",
    d: "m2054 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s258",
    d: "m1884.8 1184.3c-6.4-3.1-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s259",
    d: "m1715.7 1184.3c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s260",
    d: "m1546.5 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.5-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s261",
    d: "m1377.3 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s262",
    d: "m1208.1 1184.3c-6.4-3.1-83.5-39.7-83.5-83.5 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s263",
    d: "m1039 1184.3c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s264",
    d: "m869.8 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s265",
    d: "m700.6 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s266",
    d: "m531.4 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s267",
    d: "m362.3 1184.3c-6.5-3.1-83.6-39.7-83.6-83.5 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s268",
    d: "m193.1 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s269",
    d: "m23.9 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.2 82.5 82.3 8.8-4.1 82.5-39.9 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s270",
    d: "m-145.3 1184.3c-6.5-3.1-83.5-39.7-83.5-83.5 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 1100.8c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.2 82.4 82.3 8.9-4.1 82.5-39.9 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s271",
    d: "m2223.2 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s272",
    d: "m2054 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s273",
    d: "m1884.8 1353.4c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s274",
    d: "m1715.7 1353.4c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s275",
    d: "m1546.5 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s276",
    d: "m1377.3 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s277",
    d: "m1208.1 1353.4c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s278",
    d: "m1039 1353.4c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s279",
    d: "m869.8 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s280",
    d: "m700.6 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s281",
    d: "m531.4 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s282",
    d: "m362.3 1353.4c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.4 83.6-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.9 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s283",
    d: "m193.1 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.5 39.6 83.5 83.4 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.4 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s284",
    d: "m23.9 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.3-73.7-78.1-82.5-82.3-8.8 4.2-82.5 40-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s285",
    d: "m-145.3 1353.4c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.4 83.5-83.4 6.5 3 83.6 39.6 83.6 83.4 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 1270c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.4 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.3-73.6-78.1-82.5-82.3-8.8 4.2-82.4 40-82.4 82.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s286",
    d: "m2223.2 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2307.8 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s287",
    d: "m2054 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2138.6 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s288",
    d: "m1884.8 1522.6c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1969.4 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s289",
    d: "m1715.7 1522.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1800.3 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s290",
    d: "m1546.5 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1631.1 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s291",
    d: "m1377.3 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1461.9 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s292",
    d: "m1208.1 1522.6c-6.4-3-83.5-39.6-83.5-83.4 0-43.8 77.1-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1292.7 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s293",
    d: "m1039 1522.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.6 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s294",
    d: "m869.8 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.4 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s295",
    d: "m700.6 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m785.2 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s296",
    d: "m531.4 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m616 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s297",
    d: "m362.3 1522.6c-6.5-3-83.6-39.6-83.6-83.4 0-43.8 77.1-80.5 83.6-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m446.9 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.6 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.9 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s298",
    d: "m193.1 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.5 39.7 83.5 83.5 0 43.8-77 80.4-83.5 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m277.7 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s299",
    d: "m23.9 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m108.5 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.6-37.9-84.6-84.6 0-46.7 84.6-84.6 84.6-84.6 0 0 84.6 37.9 84.6 84.6zm-167.1 0c0 42.3 73.7 78.1 82.5 82.3 8.8-4.2 82.5-40 82.5-82.3 0-42.4-73.7-78.2-82.5-82.3-8.8 4.1-82.5 39.9-82.5 82.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s300",
    d: "m-145.3 1522.6c-6.5-3-83.5-39.6-83.5-83.4 0-43.8 77-80.5 83.5-83.5 6.5 3 83.6 39.7 83.6 83.5 0 43.8-77.1 80.4-83.6 83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m-60.7 1439.2c0 46.7-84.6 84.6-84.6 84.6 0 0-84.5-37.9-84.5-84.6 0-46.7 84.5-84.6 84.5-84.6 0 0 84.6 37.9 84.6 84.6zm-167 0c0 42.3 73.6 78.1 82.4 82.3 8.9-4.2 82.5-40 82.5-82.3 0-42.4-73.6-78.2-82.5-82.3-8.8 4.1-82.4 39.9-82.4 82.3z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    fillRule: "evenodd",
    className: "s301",
    d: "m2159.9 1.1v1438.2h-2157.3v-1438.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProject);
export default __webpack_public_path__ + "static/media/NewProject.895a3d4fb2eb30496d21fa062185705f.svg";
export { ForwardRef as ReactComponent };